import axios from "axios";
import { APIHOST } from "@/config";
const apihost = APIHOST[process.env.NODE_ENV];
axios.defaults.baseURL = apihost;
const post = async (code, title, contents, timestamp) => {
    const result = await axios.post("/document", {
        code,
        title,
        contents,
        timestamp,
    });
    return result;
};
async function list(code) {
    const result = await axios.get("/board/" + code);
    if (result.status.toString().startsWith("2") == false)
        throw new Error(result.data);
    return result.data;
}
async function get(id) {
    const result = await axios.get("/document/" + id);
    if (result.status.toString().startsWith("2") == false)
        throw new Error(result.data);
    return result.data;
}
async function update(id, title, contents) {
    const result = await axios.put("/document/" + id, {
        title,
        contents,
    });
    if (result.status.toString().startsWith("2") == false)
        throw new Error(result.data);
    return result.data;
}
async function drop(id) {
    const result = await axios.delete("/document/" + id);
    if (result.status.toString().startsWith("2") == false)
        throw new Error(result.data);
    return result.data;
}
export default {
    post,
    list,
    get,
    update,
    drop,
};
